export default {
    intro: `其中夹杂着生硬或错误的表达。<br />找出生硬的部分，改成正确的表达吧！`,
    select: '请选择', fill: '将生硬的部分自然地修改吧！',
    wrong: '哎呀，答错了。请再试一次。', find: '找出生硬的部分并点击吧。',
    findCount: '个剩余。',
    table: { question: '题目', answerRate: '正确率', emptyMessage: '没有内容。' },
};
